<template>
  <form class="signUp findId" id="signupForm" v-kendo-validator @submit.prevent="onSubmit(userNm, spTelNo)">
    <p class="etext">아이디를 잊으셨나요? 아래의 정보를 입력해주세요 </p>
    <fieldset>
      <label class="k-form-field">
        <input
            type="text"
            name="userNm"
            class="signUpInput"
            v-model="userNm"
            placeholder="이름"
            validationMessage="이름을 입력해 주세요"
            autofocus required
        >
      </label>
      <label class="k-form-field">
        <input
            type="text"
            name="spTelNo"
            class="signUpInput"
            v-model="spTelNo"
            validationMessage="전화번호를 입력해 주세요"
            placeholder="전화번호 예)01011112222"
            required>
      </label>
      <p class="lnote status">
      </p>
      <input type="submit" value="확인" class="mid_btn orange login_btn">
    </fieldset>
    <p class="balink">
      <router-link to="/login">로그인화면으로 돌아가기</router-link>
    </p>
  </form>
</template>

<script>
import { mapState } from 'vuex'
import ApiConfig from '@/api/api.config'
import ApiUtil from '@/api/api.util'

export default {
  name: 'FindId',
  data () {
    return {
      userNm: null,
      spTelNo: null,
      resultData: {},
      userId: '',
    }
  },
  props: [
    'param'
  ],
  methods: {
    /** 전화번호로 아이디 찾기**/
    onSubmit (userNm, spTelNo) {
      const vm = this
      const validator = this.kendoValidator
      if (validator.validate()) {
        const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/auth/findId.json`
        const param = {
          userNm: userNm,
          spTelNo: spTelNo,
        }

        ApiUtil.post(url, param).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            return false
          }
          const resultStatus = response.data.resultStatus

          if (resultStatus.messageCode !== '2000') {
            kendo.alert(resultStatus.messageText)
            return false
          }
          vm.resultData = response.data.resultData
          vm.$emit('child', vm.resultData)
        })
      } else {
        const errors = validator.errors()
        kendo.alert(errors[0])
      }
    },
  },
  computed: {
    ...mapState({
      errors: state => state.loginStore.loginErrors
    })
  }
}

</script>
